<template>
  <div class="h-100">
    <nav class="navbar navbar-expand-lg p-0">
            <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                <div class="navbar-nav w-100 top-nav-bar">
                    <a class="nav-item nav-link" v-on:click="changeComponent('show-installed-plugins');" :class='(activeIndex === "show-installed-plugins")?"active":"inactive"' style="width:20%">{{$t('Installed Plugins')}}<span class="sr-only">(current)</span></a>
                    <a class="nav-item nav-link" v-on:click="changeComponent('add-plugins'); " :class='(activeIndex === "add-plugins")?"active":"inactive"' style="width:20%">{{$t('Plugins Store')}}</a>
                </div>
            </div>
        </nav>
    <component :is="selectedPluginComponent"
    @changeSelectedPluginComponent='changeSelectedPluginComponent'
    style="width:100%;height:calc(100% - 42px)" 
     ></component>
  </div>
</template>

<script>
import showPlugins from "./showInstalledPlugins.vue";
import addPlugins from "./addPlugins.vue";

export default {
  name: "Bins",
  data() {
    return {
      selectedPluginComponent: "show-installed-plugins",
      selectedPluginInfo: {},
      showAddPlugins:false,
      activeIndex:"show-installed-plugins",
    };
  },
  components: {
    "show-installed-plugins": showPlugins,
    "add-plugins":addPlugins,
  },
  methods: {
    changeComponent(compName) {
      this.selectedPluginComponent = compName;
      this.activeIndex = compName;
    },
    openAddPlugins(){
        this.showAddPlugins = true;
    },
    closeModel(){
        this.showAddPlugins = false;
    },
  },
  computed:{
    //   currentProperties() {
    //   if (this.selectedPluginComponent === "bins-info") {
    //     return { selectedPluginUd : this.selectedPluginInfo.bin_id};
    //   }
    //   else{
    //       return {}
    //   }
    // },
  },
  created(){
  }
};
</script>

<style scoped lang="scss">
 $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;

.nav-item{
    color: $dull-text-color !important;
}

.inactive:hover{
  color:$text-color !important;
}

.active{
    background: $primary-background !important;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue ;
    font-weight: 500;
    font-size:15px;
}
.top-nav-bar{
    background: $primary-background;
}


/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}


</style>